import { Row } from "react-bootstrap";
import styled from "styled-components";

export const StyledPublications = styled(Row)`
  @media (max-width: 768px) {
    > div {
      justify-content: center;

      * {
        text-align: center !important;
      }
    }
  }
`;

export const PublicationEntry = styled.article`
  .meta {
    color: #555;
    font-size: var(--min-text);
    margin-bottom: 6px;
  }

  a,
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: var(--small-text);
    font-weight: 700;
    line-height: 1.5;
    margin: 0;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  p {
    margin: 8px 0 0;
    font-size: var(--min-text);
    line-height: 1.7;
    color: #333;
  }

  span {
    display: block;
    margin-top: 6px;
    color: #555;
    font-size: var(--min-text);
  }
`;
